export default __webpack_public_path__ + "static/media/syrup-nft.2201815e.png";